import { createEvent, restore, sample } from 'effector'
import { fx, path } from 'src/libs'
import { toPath } from '../../../../../features/router'
import { RequestError } from '../../../../../shared/errorResponse'
import { OfferGroupItem } from '../types'

export const setOfferForm = createEvent<OfferGroupItem>()

export const setError = createEvent<RequestError>()

export const submitCreateOffer = createEvent<OfferGroupItem>()

export const $offer = restore(setOfferForm, {
  title: '',
  isVisible: true,
})

export const createOffer = fx<OfferGroupItem, void>({
  method: 'POST',
  url: '/partner/material/offer',
})

export const $error = restore(setError, {
  message: '',
  code: 0,
})

sample({
  clock: submitCreateOffer,
  fn: (offer) => {
    return {
      url: `/partner/material/offer`,
      body: { ...offer },
    }
  },
  target: createOffer,
})

sample({
  clock: createOffer.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setError],
})

sample({
  clock: [createOffer.doneData],
  target: toPath.prepend(path.ib.ad.offers.entry),
})
